<template>
  <div class="loading-container">
    <b-loading :is-full-page="true" v-model="isLoading" />
  </div>
</template>
<style lang="css">
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
<script>
import { mapActions } from "vuex";
import { Logger } from "@/logging";
import { get_redirect_url_map } from "@/helper/redirectUrls";

const logger = new Logger("PayPalCapture");
const endpoints = require("@/api/endpoints");

export default {
  name: "PayPalCapture",
  methods: {
    ...mapActions("payment", ["paypalCapture"]),
    goPaymentCompletedPage() {
      this.$router.push({
        path: "/payment/completed",
        query: this.$route.query,
      });
    },
  },
  mounted() {
    const idempotence = this.$route.params.idempotence;

    if (idempotence == null) {
      return this.$router.go(-1);
    }

    endpoints
      .paypal_capture(this.$axios, {
        idempotency_key: idempotence,
        ...get_redirect_url_map(),
      })
      .then((response) => {
        const data = response.data;

        if (response.status == 200) {
          if (data.redirect_url != null) {
            window.location.href = data.redirect_url;
          } else {
            logger.debugError(
              "Failed to capture given idempotence and redirecting to the failed page",
              response
            );
            this.goPaymentCompletedPage();
          }
        } else {
          console.error("paypal_payment - response", response);
          this.goPaymentCompletedPage();
        }
      })
      .catch((e) => {
        logger.debugError(
          "Failed to capture given idempotence and redirecting to the failed page",
          e
        );
        this.goPaymentCompletedPage();
      });
  },
  data() {
    return {
      isLoading: true,
    };
  },
};
</script>
